//Configure Log Level
log.setLevel(process.env.LOG_LEVEL !== undefined ? process.env.LOG_LEVEL : log.levels.WARN)

//Log version for debugging
log.info(`NAR Payment Client v${process.env.BUILD_INFO.version}`)

//Export class instance
import NarPaymentClient from './NarPaymentClient'
export default new NarPaymentClient()
